import { gridBaseProps } from '../../../utils/gridBaseProps';

export const gridProps = {
  ...gridBaseProps,
  showToolbar: false,
};
